import styled, { css } from 'styled-components';
import { colors } from '../../../assets/variables';

const Wrap = styled.div`
  position: relative;
  width: 100%;
`;

const BoxWrap = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 28px 32px;
  margin-bottom: 24px;

  @media (max-width: 600px) {
    padding: 22px 18px;
    margin-bottom: 18px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  color: #174489;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
`;

const ErrorWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0;

  @media (min-width: 801px) {
    flex-direction: row;
  }
`;

const ErrorList = styled.ul`
  margin: 0;
  padding-left: 24px;
  color: ${colors.error};
  font-weight: 600;

  li {
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const List = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 72px;
  padding: 12px 0;
  margin: 0;

  &:before {
    content: none !important;
  }

  img {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    object-fit: contain;
    padding: 6px;
    background: #f7f9f8;
    border-radius: 6px;
  }
`;

const ListQuantity = styled.div`
  flex-shrink: 0;
  min-width: 36px;
  color: ${colors.primary};
  font-size: 16px;
  font-weight: 700;
  margin-right: 10px;

  ${(props) =>
    props.disabled &&
    css`
      color: ${colors.disabled};
      text-decoration: line-through;
    `}
`;

const ListText = styled.div`
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;

  ${(props) =>
    props.disabled &&
    css`
      color: ${colors.disabled};
      text-decoration: line-through;
    `}
`;

const TextGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-left: 16px;

  @media (max-width: 600px) {
    margin-left: 12px;
  }
`;

const ProductList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ErrorMessage = styled.div`
  margin: 0 0 12px 80px;
  padding: 10px 12px;
  background: #fff4f4;
  border-radius: 6px;
  color: ${colors.error};
  font-size: 13px;
  line-height: 1.4;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

const AddressWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const AddressBlock = styled.div`
  padding: 18px 20px;
  background: #f7f9f8;
  border-radius: 8px;
  margin-bottom: 20px;
`;

const FullAddress = styled.div`
  margin-top: 14px;
  padding: 12px 14px;
  background: #f7f9f8;
  border-radius: 6px;
  color: ${colors.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
`;

const Postcode = styled.p`
  margin: 0;

  font-size: 14px;
  font-weight: 600;
  color: #666666;

  span {
    display: block;
    margin-top: 4px;
    color: #174489;
    font-family: 'DM Sans', sans-serif;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.2;
  }

  @media (max-width: 600px) {
    span {
      font-size: 30px;
    }
  }
`;

const Disclaimer = styled.p`
  margin: 20px 0 0;
  padding-top: 16px;
  border-top: 1px solid #eeeeee;
  color: #666666;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  line-height: 1.6;

  a {
    color: #174489;
    font-weight: 600;
  }
`;

const OrderOrganisation = styled.div`
  margin: -8px 0 24px;
  padding: 12px 14px;
  background: #f7f9f8;
  border-radius: 6px;
  color: #666666;
  font-size: 13px;
  line-height: 1.5;

  strong {
    color: #333333;
  }
`;

const CheckoutFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  padding-top: 24px;
  border-top: 1px solid #e6e6e6;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const SubmitButton = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    min-width: 180px;
    height: 50px;
  }

  @media (max-width: 600px) {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

const CheckButton = styled.div`
  background-color: #d7f1ff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

const ListWrap = styled.div`
  border-bottom: 1px solid #e6e6e6;

  &:last-child {
    border-bottom: none;
  }
`;

const desktopStyles = css`
  ${AddressWrap} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export default {
  Wrap,
  BoxWrap,
  SectionHeader,
  SectionTitle,
  List,
  ListQuantity,
  ProductList,
  ListText,
  ErrorMessage,
  Disclaimer,
  AddressWrap,
  AddressBlock,
  Postcode,
  FullAddress,
  ErrorWrap,
  TextGroup,
  CheckButton,
  ErrorList,
  ListWrap,
  OrderOrganisation,
  CheckoutFooter,
  SubmitButton,
};
